export default "__VITE_ASSET__85771c11__"